import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from './store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from './format-read-settings/format-read-settings.util';
import { JsonCopySource } from 'app/model/pipeline/copysource/json.source';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JsonCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class JsonCopySourceAdapter extends CopySourceAdapter<JsonCopySource, Model.JsonSource> {
    protected override async _toResource(copySource: JsonCopySource): Promise<Model.JsonSource> {
        const result: Model.JsonSource = this.getCommonCopySourceProperties(copySource, JsonCopySource.MODEL.name);

        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);
        return result;
    }

    protected override async _toModel(source: Model.JsonSource, copyActivity: CopyActivity): Promise<JsonCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            JsonCopySource.MODEL,
            source,
            copyActivity
        ) as JsonCopySource;

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);
        return result;
    }
}
